import { render, staticRenderFns } from "./groupbuy_company_store_page.vue?vue&type=template&id=52d70a7c&scoped=true"
import script from "./groupbuy_company_store_page.vue?vue&type=script&lang=js"
export * from "./groupbuy_company_store_page.vue?vue&type=script&lang=js"
import style0 from "./groupbuy_company_store_page.vue?vue&type=style&index=0&id=52d70a7c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52d70a7c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/riverlei/project/java/bgyy-project/front-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('52d70a7c')) {
      api.createRecord('52d70a7c', component.options)
    } else {
      api.reload('52d70a7c', component.options)
    }
    module.hot.accept("./groupbuy_company_store_page.vue?vue&type=template&id=52d70a7c&scoped=true", function () {
      api.rerender('52d70a7c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/group_buy/company/groupbuy_company_store_page.vue"
export default component.exports